import React from 'react';
import { css } from '@emotion/react';
import { IMdResident } from '@/types/api/medical/getResidents';
import { useTranslation } from 'react-i18next';
import { color } from '@/styles';

interface Props {
  resident: IMdResident;
}

const Container = css`
  margin-top: 10px;
  min-width: 186px;
  height: 110px;
`;

const Unregistered = css`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 70px;
  font-weight: 700;
  color: ${color.thin_gray};
`;

const Disconnected = css`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  font-weight: 700;
  color: ${color.thin_gray};
  border-top: 2px solid ${color.bg_light_gray};
  border-bottom: 2px solid ${color.bg_light_gray};
  box-shadow: 0px 0px 9.66px 0px ${color.white};
`;

const VolumeContainer = css`
  margin-bottom: 47px;
  height: 100%;
  padding: 10px 6px 12px 6px;
  display: flex;
  flex-direction: column;
  color: #8ec2ec;
  line-height: 1;
  border-top: 2px solid #c7e1f5;
  border-bottom: 2px solid #c7e1f5;
`;

const VolumeTitle = css`
  font-size: 14px;
  font-weight: 700;
  text-align: center;
`;

const CupVolume = css`
  flex: 1;
  display: flex;
  align-items: flex-end;

  img {
    margin-bottom: 6px;
    width: 36px;
    height: 30px;
  }
`;

const Volume = css`
  flex: 1;
  font-family: 'DIN 1451 Std', sans-serif;
  font-size: 70px;
  text-align: center;
  line-height: 0.8;
  > span {
    font-size: 30px;
    font-weight: 400;
  }
`;

const UrineVolumeView = ({ resident }: Props) => {
  const { t } = useTranslation();

  return (
    <div css={Container}>
      {!resident.serialNumber ? (
        <div css={Unregistered}>-</div>
      ) : !resident.isDeviceActive || resident.urineVolume === null ? (
        <div css={Disconnected}>{t('notConnected', '未接続')}</div>
      ) : (
        <div css={VolumeContainer}>
          <div css={VolumeTitle}>{t('estUrineVolumeMl', '目安尿量（ml）')}</div>
          <div css={CupVolume}>
            <img src='/images/residents/meter/medical/cup.svg' alt='計量カップ' />
            <div css={Volume}>
              {Math.round(resident.urineVolume)}
              <span>ml</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UrineVolumeView;
